import type { ReactNode } from "react";

import { Flex } from "metabase/ui";
import type { ColorName } from "metabase/ui/colors/types";

import type { ComparisonResult } from "../compute";

import {
  VariationIcon,
  VariationValue,
} from "./PreviousValueComparison.styled";

interface Props {
  children: ReactNode;
  color?: ColorName;
  comparison: ComparisonResult;
  iconSize: string | number;
}

export const VariationPercent = ({
  children,
  color,
  comparison,
  iconSize,
}: Props) => {
  const { changeArrowIconName, changeColor } = comparison;

  return (
    <Flex align="center" maw="100%" style={{ color: changeColor ?? color }}>
      {changeArrowIconName && (
        <VariationIcon name={changeArrowIconName} size={iconSize} />
      )}

      <VariationValue showTooltip={false}>{children}</VariationValue>
    </Flex>
  );
};
